import React, { Fragment } from "react";
import Banner from "./Banner";
import SectionOne from "./SectionOne";
import SectionTwo from "./SectionTwo";
import SectionThree from "./SectionThree";
import SectionFour from "./SectionFour";
import SectionFive from "./SectionFive";

export default () => (
  <Fragment>
    <Banner />
    <SectionFour />
    <SectionOne />
    <SectionTwo />
    <SectionThree />
    <SectionFive />
  </Fragment>
);
